/**
 * @generated SignedSource<<c289d5cf6f2fc42f31ea179b54dcc7b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnalyticsTimeResolution = "DAY" | "MONTH" | "QUARTER" | "WEEK";
export type WorkspaceAnalyticsDimensionType = "STORE" | "WORKSPACE_OWNER";
export type WorkspaceAnalyticsSinglePeriodDetailQuery$variables = {
  groupByDimension: WorkspaceAnalyticsDimensionType;
  timeResolution: AnalyticsTimeResolution;
  workspaceId: string;
};
export type WorkspaceAnalyticsSinglePeriodDetailQuery$data = {
  readonly workspace: {
    readonly singlePeriodAnalytics: {
      readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTable">;
    } | null;
  };
};
export type WorkspaceAnalyticsSinglePeriodDetailQuery = {
  response: WorkspaceAnalyticsSinglePeriodDetailQuery$data;
  variables: WorkspaceAnalyticsSinglePeriodDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupByDimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeResolution"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "groupByDimension",
    "variableName": "groupByDimension"
  },
  {
    "kind": "Variable",
    "name": "timeResolution",
    "variableName": "timeResolution"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metric",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceAnalyticsSinglePeriodDetailQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "SinglePeriodAnalytics",
              "kind": "LinkedField",
              "name": "singlePeriodAnalytics",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SinglePeriodTable"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceAnalyticsSinglePeriodDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SinglePeriodAnalytics",
            "kind": "LinkedField",
            "name": "singlePeriodAnalytics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SinglePeriodAnalyticsMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAvg",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasTotal",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "valueUnit",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SinglePeriodAnalyticsDimension",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SinglePeriodAnalyticsDimensionMetric",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "avg",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48de3b216f87bec1dd53a728709ce2b1",
    "id": null,
    "metadata": {},
    "name": "WorkspaceAnalyticsSinglePeriodDetailQuery",
    "operationKind": "query",
    "text": "query WorkspaceAnalyticsSinglePeriodDetailQuery(\n  $workspaceId: ID!\n  $groupByDimension: WorkspaceAnalyticsDimensionType!\n  $timeResolution: AnalyticsTimeResolution!\n) {\n  workspace(id: $workspaceId) {\n    singlePeriodAnalytics(groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n      ...SinglePeriodTable\n    }\n    id\n  }\n}\n\nfragment SinglePeriodTable on SinglePeriodAnalytics {\n  metrics {\n    hasAvg\n    hasTotal\n    metric\n    valueUnit\n  }\n  dimensions {\n    label\n    metrics {\n      metric\n      avg\n      total\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "94e3b545a0039399ab2558274db711b6";

export default node;
